import { useQuery } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { UserResponse } from "~types/user";
import { transformUsersResponse } from "../utilities";

const useFetchUserList = () => {
  const request = useApi();
  const { organizationId, sport } = useParams();
  const { formatMessage } = useIntl();

  return useQuery({
    queryKey: ["permission-users", sport, organizationId],
    queryFn: async () => {
      const response: UserResponse = await request(`${sport}/o/${organizationId}/users`);
      return transformUsersResponse(response, formatMessage);
    },
  });
};

export default useFetchUserList;
